import React, { useState, useEffect } from 'react';
import { findManyProducts, getOrder, getProduct } from '../apiUser';
import Layout from '../../core/Layout';
import Shipping from '../add_product/Shipping';
import { useParams } from 'react-router-dom';
import { API } from '../../config';
import { isAuthenticated } from '../../auth';
import SenderProductsList from './SenderProductsList';
import RecieverProductList from './RecieverProductList';
import { senderGenerateShipping, recieverGenerateShipping } from './apiOrders';
import SenderParcelInfo from './SenderParcelInfo';

/* User will complete order here 
 * They will fill out payment info and confirm 
 * The checktou page will be pretty simmilar to the buy now checkout
 *
 * TODO: ask sender to enter parcel information (perhaps only if they have more than one item)
 *       - ask reciever to confirm parcel information
 *       
 */

const GenerateShippingCheckout = () => {
    const { orderId } = useParams();
    const [order, setOrder] = useState({
        recieverShipping: {name: '', street1: '', city: '', state: '', zip: '', country: ''},
        senderShipping: {name: '', street1: '', city: '', state: '', zip: '', country: ''}
    });

    const [recieverProduct, setRecieverProduct] = useState({});
    const [senderProducts, setSenderProducts] = useState([]);

    const [loading, setLoading] = useState(true);
    const [loadingText, setLoadingText] = useState('Loading Shipping Rates...');


    const platformFee = 10;

    const [paymentDetails, setPaymentDetails] = useState({
        shipping_cost: 'Loading...',
        total: 'Loading...',
        labeUrl: ''
    });

    const [error, setError] = useState('');


    const { user: { _id }, token } = isAuthenticated();

    useEffect(() => {
        getOrder(_id, orderId, token).then(async orderData => {
            console.log(orderData);
            setOrder(orderData);

            await getProduct(orderData.recieverItemId).then(recieverData => {
                setRecieverProduct(recieverData);

                if (_id === orderData.reciever) { //TODO; save these details so it doesnt have to generate if page reloads
                    recieverGenerateShipping(_id, orderData._id, token, recieverData).then(data => {
                        if (data.error) {
                            setLoading(false);
                            setError(data.error);
                        }

                        console.log(data);
                        setPaymentDetails({
                            shipping_cost: '$'+data.rateInfo.shipping_cost,
                            total: '$'+data.rateInfo.total,
                            labelUrl: data.rateInfo.toWarehouse.label_url
                        });
                        setLoading(false);
                    });
                }
            });


            await findManyProducts(orderData.senderItemIds).then(senderData => {
                console.log(senderData);
                setSenderProducts(senderData);
            });


            if (_id === orderData.sender) { 
                setLoadingText('Fill your shipping box dimensions and click "Validate Package Info"...');
            }
        });
    },[]);

    const senderSubmitParcelInfo = () => {
        if (validateParcelInfo()) {
            const senderParcelInfo = {width: dim.width, 
                length: dim.length, 
                height: dim.height, 
                weight: dim.weight, 
                distance_unit: 'in',
                mass_unit: 'lb'
            }
            setLoadingText('Getting Shipping Rates...')
            senderGenerateShipping(_id, order._id, token, senderParcelInfo).then(data => {

                setPaymentDetails({
                    shipping_cost: '$'+data.rateInfo.shipping_cost,
                    total: '$'+data.rateInfo.total,
                    labelUrl: data.rateInfo.toWarehouse.label_url
                });

                setLoading(false);
            });
        }
    };

    const validateParcelInfo = () => {
        setError('');
        if (parseInt(dim.width) < 1 || dim.width === '') {
            setError('Please enter a valid width value');
            return false;
        }
        else if (parseInt(dim.length) < 1 || dim.length === '') {
            setError('Please enter a valid length value')
            return false;
        }
        else if (parseInt(dim.height) < 1|| dim.height === '') {
            setError('Please enter a valid height value')
            return false;
        }
        else if (parseInt(dim.weight) < 0 || dim.weight === '') {
            setError('Please enter a valid weight value')
            return false;
        }
        else {
            return true;
        }
    };


    const ShowLoading = () => 
        loading && (
            <div className="rounded-md bg-blue-50 p-4">
                <div className="flex">

                    <div className="ml-3 flex-1 md:flex md:justify-between">
                        <p className="text-sm text-blue-700">{loadingText}</p>
                    </div>
                </div>
            </div>
        );

    const ShowError = () => (
        <div className="rounded-md bg-red-50 p-4" style={{display: error ? '' : 'none'}}>
            <div className="flex">
                <div className="ml-3">
                    <div className="mt-2 text-sm text-red-700 ">
                        <p className='pl-5 space-y-1'> {error} </p>
                    </div>
                </div>
            </div>
        </div>

    );

    const [dim, setDim] = useState({length: '', width: '', height: '', weight:''});
    const handleChange = name => event => {
        const value = event.target.value;
        setDim({...dim, [name]: value});
    };


    return (
        <Layout>
            <div className="bg-gray-50">
                <div className="max-w-2xl mx-auto pt-16 pb-24 px-4 sm:px-6 lg:max-w-7xl lg:px-8">
                    <h2 className="sr-only">Generate Shipping Label</h2>
                    <h3 className='text-2xl'>Generate Shipping Label</h3>
                    <form className="lg:grid lg:grid-cols-2 lg:gap-x-12 xl:gap-x-16">
                        <div className='mt-5'>
                            <dt className="font-medium text-gray-900">Delivery Address</dt>
                            <dd className="mt-1 text-gray-500">

                                {_id === order.reciever ?
                                    <>
                                        <span className="block">{order.recieverShipping.name}</span>
                                        <span className="block">{order.recieverShipping.street1}</span>
                                        <span className="block">{order.recieverShipping.city}  {order.recieverShipping.state} {}</span>
                                    </>
                                    :
                                    <>
                                        <span className="block">{order.senderShipping.name}</span>
                                        <span className="block">{order.senderShipping.street1}</span>
                                        <span className="block">{order.senderShipping.city}  {order.senderShipping.state} {}</span>
                                        <div className='mt-4'>
                                        <SenderParcelInfo handleChange={handleChange} dim={dim}/>
                                        </div>
                                        <button
                                            onClick={senderSubmitParcelInfo}
                                            type="button"
                                            className="inline-flex items-center px-2.5 py-1.5 border border-transparent text-xs font-medium rounded text-indigo-700 bg-indigo-100 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 mt-2"
                                        >
                                            Validate Package Info
                                        </button>
                                    </>
                                }
                            </dd>

                        </div>

                        {/* Order summary */}
                        <div className="mt-10 lg:mt-0">
                            <h2 className="text-lg font-medium text-gray-900">You recieve</h2>

                            <div className="mt-4 bg-white border border-gray-200 rounded-lg shadow-sm">
                                <h3 className="sr-only">Items</h3>
                                <div className='divide-y divide-gray-200'>
                                    { order.reciever === _id ?
                                        <SenderProductsList products={senderProducts}/>
                                        :
                                        <RecieverProductList product={recieverProduct}/>
                                    }
                                </div>

                                <dl className="border-t border-gray-200 py-6 px-4 space-y-6 sm:px-6">
                                    <div className="flex items-center justify-between">
                                        <dt className="text-sm">Platform Fee</dt>
                                        <dd className="text-sm font-medium text-gray-900">{platformFee}</dd>
                                    </div>
                                    <div className="flex items-center justify-between">
                                        <dt className="text-sm">Shipping</dt>
                                        <dd className="text-sm font-medium text-gray-900">{paymentDetails.shipping_cost}</dd>
                                    </div>

                                    <div className="flex items-center justify-between border-t border-gray-200 pt-6">
                                        <dt className="text-base font-medium">Total</dt>
                                        <dd className="text-base font-medium text-gray-900">{paymentDetails.total}</dd>
                                    </div>
                                </dl>

                                <ShowError />


                                <div className="border-t border-gray-200 py-6 px-6 mx-auto justify">
                                    <ShowLoading/>

                                    {!loading && 
                                    <>
                                        {_id === order.reciever ?
                                            <form action={`${API}/reciever-create-checkout-session/${order._id}`} method='POST'>
                                                <button
                                                    type="submit"
                                                    className="w-full bg-indigo-600 border border-transparent rounded-md shadow-sm py-3 px-4 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-indigo-500"
                                                >
                                                    Pay and Generate Shipping Label
                                                </button>
                                            </form>
                                            :

                                            <form action={`${API}/sender-create-checkout-session/${order._id}`} method='POST'>
                                                <button
                                                    type="submit"
                                                    className="w-full bg-indigo-600 border border-transparent rounded-md shadow-sm py-3 px-4 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-indigo-500"
                                                >
                                                    Pay and Generate Shipping Label
                                                </button>
                                            </form>
                                        }
                                    </>


                                    }
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>


        </Layout>
    )
} 

export default GenerateShippingCheckout;
